<p-panel
  [toggler]="'header'"
  [toggleable]="false"
  [collapsed]="false"
  styleClass="active-packs-panel"
>
  <ng-template pTemplate="header">
    <div class="active-packs-panel__header">
      <div class="active-packs-panel__title-wrap">
        <div class="active-packs-panel__icon">
          <i class="pi pi-wifi"></i>
        </div>
        <div class="active-packs-panel__title">
          Активные пакеты трафика
        </div>
        <p-badge
          *ngIf="activePack?.activePacksItems.length > 0"
          [value]="activePack?.activePacksItems.length"
          severity="danger"
        ></p-badge>
      </div>
    </div>
  </ng-template>

  <div class="active-packs" *ngIf="activePack?.activePacksItems?.length > 0; else emptyState">
    <div class="active-pack-card" *ngFor="let activePackItem of activePack?.activePacksItems">
      <div class="active-pack-card__top">
        <div class="active-pack-card__icon">
          <i class="pi pi-circle"></i>
        </div>

        <div class="active-pack-card__main">
          <div class="active-pack-card__title">
            {{ activePackItem.itemName }}
          </div>
        </div>
      </div>

      <div class="active-pack-card__traffic-list" *ngIf="activePackItem.remainTraffic?.length > 0">
        <div class="active-pack-card__traffic-row" *ngFor="let remainTraffic of activePackItem.remainTraffic">
          <span class="active-pack-card__traffic-name">{{ remainTraffic.name }}</span>
          <span class="active-pack-card__traffic-value">{{ remainTraffic.value }}</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template #emptyState>
    <div class="active-packs__empty">
      <i class="pi pi-info-circle"></i>
      <span>Активные пакеты отсутствуют</span>
    </div>
  </ng-template>
</p-panel>


